import React from 'react';
import { Button, Typography, Space, Divider } from 'antd';
import { CheckCircleOutlined, SafetyOutlined, ClockCircleOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './SubscriptionPending.css';

const { Title, Paragraph, Text } = Typography;

const SubscriptionPending: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="subscription-pending-page">
      {/* Navigation */}
      <nav className="pending-navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <img src="/sns-focus-logo.png" alt="SNS Intelligence" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <section className="pending-section">
        <div className="pending-container">
          <div className="success-icon-wrapper">
            <CheckCircleOutlined className="success-icon" />
          </div>

          <Title level={1} className="pending-title">
            Thank You for Your Subscription!
          </Title>

          <Paragraph className="pending-subtitle">
            Your payment has been received successfully.
          </Paragraph>

          <div className="pending-card">
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <div className="info-section">
                <ClockCircleOutlined className="info-icon" />
                <Title level={3}>What Happens Next?</Title>
                <Paragraph className="info-text">
                  Our verification team will review your company details and contact you within <strong>48 hours</strong> with your portal login credentials.
                </Paragraph>
              </div>

              <div className="info-section">
                <SafetyOutlined className="info-icon security" />
                <Title level={3}>Why Verification?</Title>
                <Paragraph className="info-text">
                  We manually verify every subscriber to protect client data and ensure only authorized organizations access our market intelligence platform.
                </Paragraph>
              </div>

              <div className="notice-box">
                <Text className="notice-text">
                  <strong>Note:</strong> If we are unable to verify your account, your payment will be fully refunded within 3-5 business days.
                </Text>
              </div>
            </Space>
          </div>

          <div className="contact-info">
            <Paragraph className="contact-text">
              Have questions? Contact us at <a href="mailto:info@snsintel.com">info@snsintel.com</a>
            </Paragraph>
          </div>

          <Button
            type="primary"
            size="large"
            icon={<HomeOutlined />}
            onClick={() => navigate('/')}
            className="home-button"
          >
            Back to Home
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer className="pending-footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-logo-section">
              <div className="footer-logo">
                <img src="/sns-focus-logo.png" alt="SNS Intelligence" />
              </div>
            </div>
            <div className="footer-links-section">
              <div className="footer-column">
                <Title level={5}>Product</Title>
                <div className="footer-links">
                  <a href="/platform">Platform</a>
                  <a href="/data-coverage">Data Coverage</a>
                  <a href="/markets">Markets</a>
                  <a href="/pulse">Pulse</a>
                </div>
              </div>
              <div className="footer-column">
                <Title level={5}>Company</Title>
                <div className="footer-links">
                  <a href="/about">About</a>
                  <a href="/contact">Contact</a>
                  <a href="/press">Press</a>
                </div>
              </div>
            </div>
          </div>
          <Divider />
          <div className="footer-bottom">
            <Text>© 2026 SNS Intelligence. All rights reserved.</Text>
            <div className="footer-legal">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-service">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SubscriptionPending;

